/* tslint:disable */
/* eslint-disable */
/**
 * WAG TP Request API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WAGTPResponse,
    WAGTPResponseFromJSON,
    WAGTPResponseFromJSONTyped,
    WAGTPResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface WAGTPResponseWrap
 */
export interface WAGTPResponseWrap {
    /**
     * 
     * @type {WAGTPResponse}
     * @memberof WAGTPResponseWrap
     */
    response: WAGTPResponse;
}

export function WAGTPResponseWrapFromJSON(json: any): WAGTPResponseWrap {
    return WAGTPResponseWrapFromJSONTyped(json, false);
}

export function WAGTPResponseWrapFromJSONTyped(json: any, ignoreDiscriminator: boolean): WAGTPResponseWrap {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'response': WAGTPResponseFromJSON(json['response']),
    };
}

export function WAGTPResponseWrapToJSON(value?: WAGTPResponseWrap | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'response': WAGTPResponseToJSON(value.response),
    };
}


